import { RuleObject } from 'antd/es/form';

import { DnsRecordFormInputs, DnsRecordFormValidationSchema } from '@/modules/DnsRecords';

export const dnsRecordsFormValidationSchema: DnsRecordFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву DNS запису' },
    { type: 'string', message: 'Назва має бути строкою' },
    { min: 3, max: 255, message: 'Назва має бути довжиною не менше 3 символа та не більше 255' }
  ],
  records: [
    {
      // eslint-disable-next-line require-await, @typescript-eslint/no-explicit-any
      validator: async (_, nsrs): Promise<any> => {
        if (!nsrs || nsrs.length < 1) {
          // eslint-disable-next-line unicorn/no-useless-promise-resolve-reject
          return Promise.reject(new Error('Введіть хоча б один NS запис'));
        }
      }
    }
  ],
  record: [
    {
      required: true,
      type: 'string',
      message: 'Введіть коректний NS запис',
      pattern: /^(([\dA-Za-z]|[\dA-Za-z][\w-]*[\dA-Za-z])\.)*([\dA-Za-z]|[\dA-Za-z][\dA-Za-z-]*[\dA-Za-z])$/
    },
    ({ getFieldValue }): RuleObject => ({
      validator(): Promise<void> {
        if (getFieldValue([DnsRecordFormInputs.Records]).length !== new Set(getFieldValue([DnsRecordFormInputs.Records])).size) {
          return Promise.reject(new Error('Однакові NS записи не допускаються'));
        }
        return Promise.resolve();
      }
    })
  ],
  apiProvider: [{ required: true, type: 'string', message: 'Виберіть API провайдер' }],
  apiProviderAccountId: [{ required: true, type: 'string', message: 'Виберіть акаунт API провайдера' }]
};
